var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.002 10.393 3.58-3.573A.836.836 0 0 0 14.4 5.638l-3.572 3.58-3.571-3.58A.836.836 0 1 0 6.074 6.82l3.58 3.573-3.58 3.571a.83.83 0 0 0 0 1.183.834.834 0 0 0 1.183 0l3.571-3.58 3.572 3.58a.833.833 0 0 0 1.364-.271.83.83 0 0 0-.182-.912z"
  })));
};
export default SvgCross;